import { Page } from '@markant-platform/shared/data-access';
import { TableCellDateFormat } from '@markant-platform/shared/table/model';
import { BillingPeriod } from '@markant-platform/cartridge/model';

export type UsageAggregationPage = {
  requestedStart?: Date;
  requestedEnd?: Date;
  totalAggregation: number;
} & Page<UsageAggregation>;

export type UsageAggregation = {
  id: string;
  totalUsages: number;
};

export type UsageAggregationFilter = {
  servicePackageId: string;
  serviceIds: string[];
  frequency: UsageAggregationFrequency;
  periodStart: Date;
  periodEnd: Date;
};

export enum UsageAggregationFrequency {
  DAILY = 'DAILY',
  MONTHLY = 'MONTHLY',
  YEARLY = 'YEARLY', // does not have a real impact right now
}

export const UsageAggregationFrequencyDateFormatMap: Record<UsageAggregationFrequency, TableCellDateFormat> = {
  [UsageAggregationFrequency.DAILY]: 'long',
  [UsageAggregationFrequency.MONTHLY]: 'medium',
  [UsageAggregationFrequency.YEARLY]: 'short',
};

export const UsageAggregationFrequencyBillingPeriodMap: Record<BillingPeriod, UsageAggregationFrequency> = {
  MONTHLY: UsageAggregationFrequency.DAILY,
  YEARLY: UsageAggregationFrequency.MONTHLY,
  NONE: UsageAggregationFrequency.MONTHLY,
  QUARTERLY: UsageAggregationFrequency.MONTHLY,
  HALF_YEARLY: UsageAggregationFrequency.MONTHLY,
};
